var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.659,
    height: 13.192,
    viewBox: "0 0 14.659 13.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-8.03 -50.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24195",
    "data-name": "Path 24195",
    d: "M10.649,50.95H22.133a.357.357,0,0,1,.357.357V61.833a.356.356,0,0,1-.14.283l-1.633,1.528a.354.354,0,0,1-.242.1l-9.825,0a.357.357,0,0,1-.357-.357V62.33L8.348,60.2a.355.355,0,0,1-.118-.265V54.028a.357.357,0,0,1,.357-.357h1.706V51.307a.357.357,0,0,1,.357-.357Zm-.357,10.329V54.385H8.943V59.8l1.35,1.475ZM12.2,54.938a.357.357,0,0,1,0-.713H20.58a.357.357,0,0,1,0,.713Zm0-1.446a.357.357,0,0,1,0-.713H20.58a.357.357,0,0,1,0,.713Zm4.827,4.657a.357.357,0,0,1,0-.713h3.658a.357.357,0,0,1,0,.713Zm0,1.956a.357.357,0,0,1,0-.713h3.658a.357.357,0,0,1,0,.713ZM12.1,56.521h3.785a.357.357,0,0,1,.357.357v3.785a.357.357,0,0,1-.357.357H12.1a.357.357,0,0,1-.357-.357V56.878a.357.357,0,0,1,.357-.357Zm3.429.713H12.452v3.072h3.072Zm6.252-5.572H11.006V63.029h9.33l1.44-1.348Z",
    stroke: "#000",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicationIcon);
export default __webpack_public_path__ + "static/media/publication-icon.48f104fa4ead1cc6bcf8b444361d6caa.svg";
export { ForwardRef as ReactComponent };